<template>
    <li v-if="classes.large && isAuthenticated">
        <span
            :class="classes"
            class="account padding-lr margin"
            v-html="userName"
        />
    </li>
</template>
<script>
export default {
    name: 'NameElement',
    props: {
        isAuthenticated: {
            type: Boolean,
            default() {
                return false;
            }
        },
        classes: {
            type: [String, Object],
            default() {
                return '';
            }
        },
        userName: {
            type: String,
            default() {
                return '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';
 .large {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-large;
    }

    .function-menu {
        line-height: $menu-line-height;
    }

    .margin {
        margin :0;
    }
}

.small {
    .padding-lr {
        padding: 0 $function-menu-padding-lr;
    }

    .no-top-bottom-padding {
        padding: 0 $function-menu-padding-bottom-small;
    }

    .function-menu {
        line-height: $menu-line-height;
    }
}
</style>
